module.exports = __webpack_public_path__ + "static/intro-85f2ff43834fe349d74374510cdf433a.svg";